import { AdminApiService } from '../services';
import type { TaskUpdate } from '../services';

export type GetTasksPayload = {
  filters?: {
    search?: string | null;
    campaignId?: string | null;
    status?: string | null;
    taskType?: string | null;
  };
  page: ApiPaginationType;
};

export const getTasks = ({ filters, page }: GetTasksPayload) => {
  return AdminApiService.getTasksApiAdminTasksGet(
    undefined,
    filters?.campaignId,
    filters?.status,
    filters?.taskType,
    page?.limit,
    page?.offset
  );
};

export const updateTask = (id: string, payload: TaskUpdate) => {
  return AdminApiService.updateTaskApiAdminTasksTaskIdPatch(id, payload);
};
export const deleteTask = (id: string) => {
  return AdminApiService.deleteTaskApiAdminTasksTaskIdDelete(id);
};

export type { TaskResponse } from '../services';
export type TaskUpdatePayload = TaskUpdate;
